import { memo } from 'react';
import { formatPrice } from 'helpers';

const AllocationTypeTable = ({ selectedType }) => {
    const columns = [
        {
            name: 'Type',
            selector: 'type',
        },
        {
            name: 'Total Amount',
            selector: 'totalAmount',
        },
        {
            name: 'Available Amount',
            selector: 'availableAmount',
        },
        {
            name: 'Amount After Allocation',
            selector: 'remainingAmount',
        },
    ];

    return (
        <>
            {columns.map(({ name, selector }) => (
                <div
                    key={selector}
                    className="tableRow">
                    <span>{name}</span>
                    <p>{typeof selectedType[selector] === 'number' ? formatPrice(selectedType[selector]) : selectedType[selector]}</p>
                </div>
            ))}
        </>
    );
};

export default memo(AllocationTypeTable);
